/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/12/2021
 */

import {createDialogLazy} from "@/utils/helpers-external";

let PickOrCreateClientDialog = () => import("./PickOrCreateClientDialog")
let PickOrCreateClientProfileDialog = () => import("./PickOrCreateClientProfileDialog")
let ClientEmailPickerDialog = () => import("./ClientEmailPickerDialog")
let ClientPickerSimpleDialog = () => import("@/core/components/Picker/ClientPickerView/ClientPickerSimpleDialog.vue");


// import PickOrCreateClientDialog from "./PickOrCreateClientDialog"
// import PickOrCreateClientProfileDialog from "./PickOrCreateClientProfileDialog"
// import ClientEmailPickerDialog from "./ClientEmailPickerDialog"
// import ClientPickerSimpleDialog from "@/core/components/Picker/ClientPickerView/ClientPickerSimpleDialog.vue";

export const pickOrCreateClientDialog = createDialogLazy(PickOrCreateClientDialog)
export const pickOrCreateClientProfileDialog = createDialogLazy(PickOrCreateClientProfileDialog)
export const pickClientSimpleDialog = createDialogLazy(ClientPickerSimpleDialog)
export const clientEmailPickerDialog = createDialogLazy(ClientEmailPickerDialog)

